export default "__VITE_ASSET__CGtZW45S__"